import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import TemplateApi from 'api/template';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import NotificationHelper from 'helpers/NotificationHelper';

const TemplateForm = ({ data }) => {
  const html = data.payload.html || '';
  const contentBlock = htmlToDraft(html);

  const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
  const editorState = EditorState.createWithContent(contentState);

  const [editor_value, setEditorValue] = useState(editorState);
  const [name_value, setNameValue] = useState(data.name);
  const [saving, setSaving] = useState(false);

  const { t } = useTranslation();
  const history = useHistory();

  const handleNameInputChange = e => {
    setNameValue(e.target.value.replace(/[^a-zA-Z0-9_-]/gi, ''));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    setSaving(true);

    const description = document.querySelector('#description_input').value;
    const name = document.querySelector('#name_input').value;
    const html = draftToHtml(convertToRaw(editor_value.getCurrentContent()));

    const bind = {
      name,
      description,
      payload: { html },
    };

    try {
      await TemplateApi.update(data.id, bind);
      setTimeout(() => history.push('/templates'), 300);
    } catch (error) {
      NotificationHelper.snack(t(`messages.unexpected_error`));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="form card" onSubmit={handleSubmit}>
      <div className="card-body">
        <div className="mb-3">
          <label htmlFor="name_input" className="form-label">
            {t('columns.name')}:
          </label>
          <input
            type="text"
            value={name_value}
            onChange={handleNameInputChange}
            required
            className="form-control"
            id="name_input"
            aria-describedby="name_help"
          />
          <div id="name_help" className="form-text">
            {t('templates.helps.name')}
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="description_input" className="form-label">
            {t('columns.description')}:
          </label>
          <input type="text" defaultValue={data.description} required className="form-control" id="description_input" />
        </div>

        <div className="mb-5">
          <label htmlFor="description_input" className="form-label">
            {t('columns.template')}:
          </label>
          <Editor editorState={editor_value} onEditorStateChange={setEditorValue} />
        </div>

        <hr />
        <SubmitButton loading={saving} className="btn btn-primary" />
      </div>
    </form>
  );
};

export default TemplateForm;
